// src/view/StyledViews.js
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { AppStyle } from '../value/AppConst';
import ImportContactsIcon from '@mui/icons-material/ImportContacts';

export const SectionTitleBox = styled(Box)({
    fontSize: '1.1rem', fontWeight: 'bold', padding: 16, display: 'block', borderRadius: 3,
    color: 'white',
    textAlign: 'center',
});

export const SectionBody = styled(Box)({
    padding: 8, marginBottom: 48
});

export const SectionTitle = ({label, disabled}) => {
    return (
        <SectionTitleBox
            sx={{
                backgroundColor: disabled ? AppStyle.DisabledRGB : AppStyle.PrimaryRGB,
            }}  
        >
            <ImportContactsIcon style={{float: 'left', marginRight: 8}} />
            {label}
        </SectionTitleBox>
    );
};

export const Plain = ({children}) => {
    return (
        <Box sx={{padding: 2, fontSize: '0.9rem', color: '#333'}}>
            {children}
        </Box>
    );
};